import { render, staticRenderFns } from "./ParceriaEuOrganico.vue?vue&type=template&id=3b712364&"
import script from "./ParceriaEuOrganico.vue?vue&type=script&lang=js&"
export * from "./ParceriaEuOrganico.vue?vue&type=script&lang=js&"
import style0 from "./ParceriaEuOrganico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports